import { msg } from "@lingui/core/macro";

export const maxTimePerVehicleInPeriodRuleMessages = {
	name: msg({ message: "Maximum Time Per Vehicle" }),
	description: msg({ message: "Maximum Parking Time Per Vehicle in a Period of Time" }),
	errors: {
		limitReached: msg({
			message: "The {period} limit of {duration} of parking time per vehicle has been reached.",
		}),
	},
} as const;
